import { LOCK_SCREEN_CLASS } from '@pet/base.popup/const';
import { useBarInfo, isInBrowser } from '@pet/base.utils';
import { transViewValue } from '@pet/core.mobile';
import { ref, computed, onBeforeUnmount } from 'vue-demi';

const scrollDistance = ref(0);

let scrollLockValue: number[] = [];
let scrollLockValueCount = 0;

function resetValues() {
    scrollDistance.value = 0;
    scrollLockValue = [];
    scrollLockValueCount = 0;
}

function handlePopupLock(distance: number, expandOpacity: number) {
    if (expandOpacity === 1) {
        scrollLockValueCount += 1;
    } else {
        scrollLockValueCount = 0;
    }

    if (scrollLockValueCount < 2) {
        scrollLockValue.push(distance);
    }
    if (distance === 0) {
        const root = document.documentElement;
        const isRootLocked = root.classList.contains(LOCK_SCREEN_CLASS);
        if (isRootLocked && scrollLockValue.length > 1) {
            scrollDistance.value = scrollLockValue.filter((val) => val !== 0).slice(-1)[0] ?? 0;
        }
    }
}

function getPageHeightInfos() {
    const root = document.documentElement;
    const pageHeight = root.clientHeight;
    const scrollHeight = root.scrollHeight;
    return {
        shouldFoldDistance: scrollHeight - pageHeight,
    };
}

export function useScroll(scrollThreshold = 10, scrollEdge = 100) {
    const opacityValue = computed(() => {
        const edge = transViewValue(scrollEdge);
        if (edge > 0) {
            return scrollDistance.value / edge < 1 ? scrollDistance.value / edge : 1;
        }
        return 1;
    });

    function getScrollDistance() {
        const { shouldFoldDistance } = getPageHeightInfos();
        const scrolledDistance = transViewValue(shouldFoldDistance - scrollEdge);
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        scrollDistance.value = scrolledDistance > scrollThreshold ? scrollTop : 0;
        handlePopupLock(scrollDistance.value, opacityValue.value);
    }

    function listenScroll() {
        if (isInBrowser) {
            window.addEventListener('scroll', getScrollDistance, {
                passive: true,
            });
        }
    }

    function removeScroll() {
        if (isInBrowser) {
            window.removeEventListener('scroll', getScrollDistance);
        }
    }

    onBeforeUnmount(() => {
        window.removeEventListener('scroll', getScrollDistance);
        resetValues();
    });

    const switchShowStyle = computed(() => {
        return {
            opacity: 1 - opacityValue.value,
        };
    });
    const switchHideStyle = computed(() => {
        return {
            opacity: opacityValue.value,
        };
    });

    return {
        scrollDistance,
        opacityValue,
        switchShowStyle,
        switchHideStyle,
        listenScroll,
        removeScroll,
    };
}

export function useTopGap(myStatusBarHeight?: number) {
    const { statusBarHeight } = useBarInfo();
    const topGap = computed(() => {
        return {
            paddingTop: `${myStatusBarHeight ?? statusBarHeight}px`,
        };
    });
    return {
        topGap,
        statusBarHeight: myStatusBarHeight ?? statusBarHeight,
    };
}
